import React from 'react'
import {translate} from 'react-i18next'
import {compose, pure} from 'recompose'
import {NavLink, Link, withRouter} from 'react-router-dom'
import styles from './smallNavComponent.scss'
import PropTypes from 'prop-types'
import BetaCorner from '../../assets/icons/betaCorner.svg'
import ContentContainer from '../contentContainer/contentContainerComponent'
import SmartShowLoginButton from '../../containers/showLoginButton/showLoginButtonContainer'
import SmartLogoutButton from '../../containers/logoutButton/logoutButtonContainer'
import SmartShowResetPasswordButton from '../../containers/showResetPasswordButton/showResetPasswordButtonContainer'
import SmartShowRegistrationButton from '../../containers/showRegistrationButton/showRegistrationButtonContainer'

/*
<BetaCorner style={{float: 'right', marginTop: 0, paddingTop: 0, position: 'relative', top: 0, right: 0, height: '10em'}} />
*/

export function SmallNav (props: Props) {
  const {t, i18n} = props
  return (
    <div>
      {props.betaCorner && (
      <div style={{float: 'right'}} >
        <BetaCorner style={{float: 'right', marginTop: 0, paddingTop: 0, position: 'absolute', top: 0, right: '-10px'}} />
      </div>
      )}
      <div className={styles.smallNav}>
        <ContentContainer>
          <ul className={styles.horizontalList}>
            <li>
              {i18n.language === 'es'
                ? <button
                  id='changelanguage_en'
                  className={styles.linkButton}
                  onClick={() => i18n.changeLanguage('en')}
                >
                  English
                </button>
                : <button
                  id='changelanguage_es'
                  className={styles.linkButton}
                  onClick={() => i18n.changeLanguage('es')}
                >
                  En Español
                </button>}
            </li>
            {!props.siteMaintBlockLogin && (
            <li>
              <SmartLogoutButton
                location={props.location}
                ariaLabel='sign out'
                className={styles.linkButton}
              >
                {t('nav:signOut')}
              </SmartLogoutButton>
            </li>
            )}
            {!props.siteMaintBlockLogin && (
            <li>
              <SmartShowLoginButton
                ariaLabel='show sign in'
                className={styles.linkButton}
              >
                {t('nav:signIn')}
              </SmartShowLoginButton>
            </li>
            )}
            {!props.siteMaintBlockRegistration && (
            <li>
              <SmartShowRegistrationButton
                ariaLabel='show registration'
                className={styles.linkButton}
              >
                {t('form:createAccount')}
              </SmartShowRegistrationButton>
            </li>
            )}
            {!props.siteMaintBlockLogin && (
            <li>
              <SmartShowResetPasswordButton
                ariaLabel='show sign in'
                className={styles.linkButton}
              >
                {t('form:changePassword')}
              </SmartShowResetPasswordButton>
            </li>
            )}
            {!props.siteMaintBlockGradPlanner && props.myPlan && (
              <li>
                <Link
                  to={'/gradplanner?GradPlanner=' + props.myPlan}
                  className={styles.linkButton}
                >
                  {t('nav:myPath')}
                </Link>
              </li>
            )}
          </ul>
        </ContentContainer>
      </div>
    </div>
  )
}

SmallNav.propTypes = {
  t: PropTypes.func.isRequired,
  myPlan: PropTypes.any,
  betaCorner: PropTypes.bool,
  siteMaintBlockLogin: PropTypes.bool,
  siteMaintBlockRegistration: PropTypes.bool,
  siteMaintBlockGradPlanner: PropTypes.bool,
  location: PropTypes.any,
  i18n: PropTypes.shape({
    changeLanguage: PropTypes.func.isRequired
  })
}

export default compose(pure, translate(), withRouter)(SmallNav)



// WEBPACK FOOTER //
// ./src/components/smallNav/smallNavComponent.js